import * as ko from "knockout";
import {KOSubscriptionTracker} from "../../util/KOSubscriptionTracker";
import show_allHtml from './show-all.html?raw';

export const template = show_allHtml;

interface IParams {
    showAll: KnockoutObservable<boolean>
    hasFocus?: KnockoutObservable<boolean>
}

export class viewModel {
    private showAll: KnockoutObservable<boolean>
    private kosub: KOSubscriptionTracker = new KOSubscriptionTracker()

    constructor(params: IParams) {
        this.showAll = params.showAll
        if (params.hasFocus) {
            this.kosub.subscribe(this.showAll, bool => {
                if (!bool) {
                    params.hasFocus?.(true)
                }
            })
        }
    }

    dispose() {
        this.kosub.unsuscribeAll()
    }
}
